export default function Device() {
    return (
        <div className='h-full bg-yellow'>
            <title>Device</title>
            <h1>Device</h1>
        </div>
    );
}
